import { render, staticRenderFns } from "./DataChart.vue?vue&type=template&id=ad15b7a0&scoped=true&"
import script from "./DataChart.vue?vue&type=script&lang=js&"
export * from "./DataChart.vue?vue&type=script&lang=js&"
import style0 from "./DataChart.vue?vue&type=style&index=0&id=ad15b7a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad15b7a0",
  null
  
)

export default component.exports